import type {
  AlineContentBlock,
  DocumentElement,
  ListDefinitions,
  PageDimensions,
} from '../internal';
import { createDefaultParagraph, defaultStyles, documentType } from '../internal';

export const minimumPageContentHeightIn = 2;
export const defaultHeaderFooterMarginIn = 0.5;
export const defaultPageDimensions: PageDimensions = {
  height: 11,
  marginBottom: 1,
  marginLeft: 1,
  marginRight: 1,
  marginTop: 1,
  width: 8.5,
};
export const documentSchemaVersion = 3;

/**
 * Create a default document element.
 *
 * - Used to provide default values for document during normalization.
 * - To aid with quick testing, we allow text and children to be passed in.
 */
export function createDefaultDocElement({
  text = '',
  children = [createDefaultParagraph({ text })],
  listDefinitions = {},
}: {
  children?: AlineContentBlock[];
  listDefinitions?: ListDefinitions;
  text?: string;
} = {}): DocumentElement {
  return {
    children,
    defaultTabStopIn: 0.5,
    headerFooter: {
      diffFirstPage: false,
      evenOdd: false,
      pageNumbering: {
        format: 'decimal',
        start: 1,
      },
    },
    listDefinitions,
    pageDimensions: defaultPageDimensions,
    schemaVersion: documentSchemaVersion,
    styleSheet: defaultStyles,
    suggestedEdits: [],
    type: documentType,
  };
}
